import { render } from "./HomeView.vue?vue&type=template&id=0854d8fa&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=0854d8fa&scoped=true&lang=scss"

import exportComponent from "/home/florian/dev/biomar/vue-starter-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0854d8fa"]])

export default __exports__